import { Box, IconButton } from "@mui/material";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import { BASE_DICT_SOUND_UK, BASE_DICT_SOUND_US } from "@/constants";
import { onPlayReadStr } from "@/helpers";

interface IWordPhoneticProps {
  word: any;
  isHiddenIPA?: boolean;
}

const WordPhonetic = (props: IWordPhoneticProps) => {
  const { word, isHiddenIPA } = props;

  const onPlaySound = (type: string) => {
    if (!word.uid) {
      onPlayReadStr(word.word, undefined, type === "us" ? "en-US" : "en-GB");
      return;
    }
    const baseSoundByType: { [key: string]: string } = {
      us: BASE_DICT_SOUND_US,
      uk: BASE_DICT_SOUND_UK,
    };
    const soundUrl = `${baseSoundByType[type]}${word.uid}.mp3`;
    const audio = new Audio(soundUrl);
    audio.play();
  };

  if (!word) {
    return <></>;
  }

  return (
    <Box
      sx={() => ({
        color: "text.primary",
        "& .phonetic_type": {
          fontWeight: "bold",
        },
        "& .phonetic_text": {},
      })}
    >
      <Box
        sx={() => ({
          display: "flex",
          alignItems: "center",
          "& span:first-of-type": {
            fontWeight: "bold",
          },
        })}
      >
        <span>US</span>
        <IconButton
          size="small"
          onClick={(e) => {
            onPlaySound("us");
            e.stopPropagation();
          }}
        >
          <VolumeUpIcon />
        </IconButton>
        {!isHiddenIPA ? (
          <span>
            {word.phonetic?.us
              ? word.phonetic?.us.indexOf("/") === 0
                ? word.phonetic?.us
                : `/${word.phonetic?.us}/`
              : ""}
          </span>
        ) : null}
      </Box>
      <Box
        sx={() => ({
          display: "flex",
          alignItems: "center",
          "& span:first-of-type": {
            fontWeight: "bold",
          },
        })}
      >
        <span>UK</span>
        <IconButton
          size="small"
          onClick={(e) => {
            onPlaySound("uk");
            e.stopPropagation();
          }}
        >
          <VolumeUpIcon />
        </IconButton>
        {!isHiddenIPA ? (
          <span>
            {word.phonetic?.uk
              ? word.phonetic?.uk.indexOf("/") === 0
                ? word.phonetic?.uk
                : `/${word.phonetic?.uk}/`
              : ""}
          </span>
        ) : null}
      </Box>
    </Box>
  );
};

export default WordPhonetic;
